import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useCandidateDrawer } from "@/components/CandidateDrawer";
import { STAGES, STAGE_MAP, stagePillClass, dbsPillClass, refsPillClass, fmtDate, initials } from "@/lib/cc";
import { Search } from "lucide-react";

export default function CandidatesPage() {
  const [cands, setCands] = useState([]);
  const [stage, setStage] = useState("");
  const [q, setQ] = useState("");
  const { open } = useCandidateDrawer();

  const load = async () => {
    const { data } = await api.get("/candidates", { params: stage ? { stage } : {} });
    setCands(data);
  };
  useEffect(() => { load(); }, [stage]);

  const filtered = cands.filter((c) => {
    if (!q) return true;
    return `${c.first_name} ${c.last_name} ${c.email} ${c.job_title}`.toLowerCase().includes(q.toLowerCase());
  });

  return (
    <div className="fade-up">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="label-eyebrow mb-2">Recruitment</div>
          <h1 className="font-display text-4xl font-bold">Candidates</h1>
          <p className="text-[var(--cc-text-soft)] mt-1">All applicants across roles, sortable by stage.</p>
        </div>
        <div className="flex gap-3">
          <select className="cc-select" value={stage} onChange={(e) => setStage(e.target.value)} data-testid="candidates-stage-filter">
            <option value="">All stages</option>
            {STAGES.map((s) => <option key={s.key} value={s.key}>{s.label}</option>)}
          </select>
          <div className="relative">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--cc-text-soft)]" />
            <input className="cc-input pl-9 w-72" placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="candidates-search-input" />
          </div>
        </div>
      </div>

      <div className="cc-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[var(--cc-surface)]">
              <tr className="text-left">
                <th className="px-5 py-3 label-eyebrow">Candidate</th>
                <th className="px-5 py-3 label-eyebrow">Role</th>
                <th className="px-5 py-3 label-eyebrow">Stage</th>
                <th className="px-5 py-3 label-eyebrow">DBS</th>
                <th className="px-5 py-3 label-eyebrow">Refs</th>
                <th className="px-5 py-3 label-eyebrow">Applied</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((c) => {
                const refsDone = (c.references || []).filter((r) => r.status === "verified" || r.status === "received").length;
                return (
                  <tr key={c.id} className="border-t border-[var(--cc-border)] hover:bg-[var(--cc-surface)] cursor-pointer transition" onClick={() => open(c.id)} data-testid={`candidate-row-${c.id}`}>
                    <td className="px-5 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-full flex items-center justify-center text-white text-xs font-bold"
                             style={{ background: "var(--cc-primary)" }}>{initials(c.first_name, c.last_name)}</div>
                        <div>
                          <div className="font-semibold">{c.first_name} {c.last_name}</div>
                          <div className="text-xs text-[var(--cc-text-soft)]">{c.email}</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-5 py-3">{c.job_title}</td>
                    <td className="px-5 py-3"><span className={`pill ${stagePillClass(c.stage)}`}>{STAGE_MAP[c.stage]}</span></td>
                    <td className="px-5 py-3"><span className={`pill ${dbsPillClass(c.dbs?.status)}`}>{(c.dbs?.status || "—").replace("_", " ")}</span></td>
                    <td className="px-5 py-3"><span className="font-semibold">{refsDone}/{c.references?.length || 0}</span></td>
                    <td className="px-5 py-3 text-[var(--cc-text-soft)]">{fmtDate(c.applied_at)}</td>
                  </tr>
                );
              })}
              {filtered.length === 0 && <tr><td colSpan="6" className="text-center py-10 text-[var(--cc-text-soft)]">No candidates found.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
